import { useEffect } from "react";
import { CircleMarker, Popup } from "react-leaflet";
import { useSelector } from "react-redux";



const CurrentLocationMarker = (props) => {
    const { currentLocation } = useSelector((state) => state.taxi);

    useEffect(()=>{
        
    }, [currentLocation])

    const validLocation = currentLocation && 
        !isNaN(currentLocation.latitude) && !isNaN(currentLocation.longitude) &&
        currentLocation.latitude !== null && currentLocation.longitude !== null;

    const element = validLocation ? (
        <>
            <CircleMarker
                center={[currentLocation.latitude, currentLocation.longitude]}
                pathOptions={{ color: "rgb(0, 136, 204)", fillColor: "rgb(0, 136, 204)", fillOpacity: 0.15, weight: 1 }}
                radius={20}
            />
            <CircleMarker
                center={[currentLocation.latitude, currentLocation.longitude]}
                pathOptions={{ color: "rgb(0, 136, 204)", fillColor: "rgb(0, 136, 204)", fillOpacity: 1, weight: 2 }}
                radius={6}
            >
                <Popup>Вы здесь</Popup>
            </CircleMarker>
        </>
    ) : null

    return element;
} 



export default CurrentLocationMarker;